import * as React from 'react'
import * as Recaptcha from 'react-recaptcha'

interface Props {
  publicKey: string
  onChange: (value: string) => void
}
export class Capatcha extends React.Component<Props, {}> {
  recaptchaInstance: Recaptcha | null
  render() {
    const { publicKey, onChange } = this.props
    return (
      <Recaptcha
        ref={e => (this.recaptchaInstance = e)}
        sitekey={publicKey}
        render="explicit"
        verifyCallback={res => {
          onChange(res)
        }}
        hl="pl"
        expiredCallback={() => {
          onChange('')
          this.recaptchaInstance && this.recaptchaInstance.reset()
        }}
        onloadCallback={e => {}}
      />
    )
  }
}
